import { FormFieldsGeneratorService } from './../../customer-form/form-helpers/form-fields-generator.service';
import { Inject, Injectable } from '@angular/core';
import { FormFieldsMasks } from '../../customer-form/field-mask/form-fields-masks';
import MsisdnFormatClear from '../../utils/pipes/msisdnFormatClear';
import {
  NotificationProviderService,
  NotificationProviderTypeEnum
} from '../../external-interfaces/notification-provider.service';
import { ICartDetails } from '../../interfaces/cart-details.interface';
import ValidationRulesService from '../../utils/services/validation-rules.service';

@Injectable()
export default class ManageTvService {
  public inputId = 'engi-input-manage-tv';
  public validationMasks: FormFieldsMasks;
  //Msisdn to manage TV
  public msisdn = '';
  public editMode = false;

  private wasEdited = false;
  private msisdnFormatClear: MsisdnFormatClear = new MsisdnFormatClear();

  constructor(
    @Inject('Endpoint') private endpoint: any,
    private notificationProvider: NotificationProviderService,
    private validationRules: ValidationRulesService,
    private formsGenerator: FormFieldsGeneratorService
  ) {
    this.validationMasks = new FormFieldsMasks();

    this.notificationProvider.subscribe(NotificationProviderTypeEnum.CART_DETAILS, (cartDetails: ICartDetails) => {
      if (!cartDetails) {
        return;
      }

      this.msisdnToManageTv(cartDetails.msisdnToManageTv);
    });
  }

  public get isEditMode(): any {
    return this.editMode;
  }

  public set isEditMode(isEditMode: any) {
    this.editMode = isEditMode;
  }

  public onEditMode(event?: Event): void {
    if (event) {
      event.preventDefault();
    }

    this.isEditMode = true;

    this.clearMsisdn();
  }

  public submit(event: Event): void {
    event.preventDefault();

    if (this.formsGenerator.activeForm.valid) {
      this.isEditMode = false;
      this.wasEdited = true;

      this.savePhone();
    }
  }

  public msisdnToManageTv(msisdn: string): void {
    if (!msisdn) {
      this.onEditMode();

      return;
    }

    this.isEditMode = false;
    this.msisdn = msisdn;
  }

  public isValid(): boolean {
    this.runValidateOnInputFieldWithCustomText();

    return !this.editMode;
  }

  private runValidateOnInputFieldWithCustomText(): void {
    const errorMsg = 'Kliknij Dalej żeby dodać numer';

    this.validationRules.addInputError(this.inputId, errorMsg);
  }

  private clearMsisdn(): void {
    if (!this.wasEdited) {
      this.msisdn = '';
    }
  }

  private savePhone(): void {
    this.isEditMode = false;

    this.endpoint('msisdn.saveTvMsisdn', {
      phone: this.msisdnFormatClear.transform(this.msisdn)
    }).run();
  }
}


